/**
 * @requires jQuery
 * @author Ei
 */
/**
 * @param  {string}   elmSelector 元素选择器
 * @param  {hash} options       {
 *                                num {number} 每次加载的个数
 *                                btn {string} 按钮选择器
 *                                callBack{function} 加载前的回调函数
 *                              }
 * @constructor
 */
export default function LinkMore(elmSelector, options = {}) {
  let $items = $(elmSelector).children('.item'),
    { btn = '.mbtn', num = 0, callBack } = options,
    $btn = $(btn),
    mark = 0;
  callBack = typeof callBack === 'function' ? callBack : function() {};

  function init() {
    linkMore();
    $btn.on('click', () => {
      linkMore();
    });
  }

  function linkMore() {
    const length = $items.length,
      start = mark;
    mark += num;
    const $targets = $items.slice(start, mark);

    if (length - mark <= 0) {
      if ($btn.fadeOut) {
        $btn.fadeOut('slow');
      } else {
        $btn.hide();
      }
    }

    if (length - start <= 0) {
      return;
    }

    callBack($items, start, num);
    $targets.addClass('active');

  }

  init();
}
const DATA_KEY = 'linkMore';
if (window.jQuery || window.Zepto) {
  (function($) {
    'use strict';
    $.fn.linkMore = function(params) {
      let firstInstance;
      this.each(function(i) {
        let data = $(this).data(DATA_KEY);
        if (!data) {
          data = new LinkMore(this, params);
          $(this).data(DATA_KEY, data);
        }
        if (!i) firstInstance = data;
      });
      return firstInstance;
    };
  })(window.jQuery || window.Zepto);
}



// WEBPACK FOOTER //
// ./src/utils/link-more.js